import { ENV_VARS } from '@/env';
import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';
const CancelToken = axiosInstance.CancelToken;

let getRoutingGuideListEffectCancelToken = () => {};
export const getRoutingGuideVal = (params = {}) => {
  getRoutingGuideListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetRoutingGuideFromSearch`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getRoutingGuideListEffectCancelToken = c;
    }),
  });
};

let getRoutingGuideIdDataCancelToken = () => {};
export const getRoutingGuideIdData = (params = {}) => {
  getRoutingGuideIdDataCancelToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetRoutingGuide`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getRoutingGuideIdDataCancelToken = c;
    }),
  });
};

const getSpotQuoteRoutingGuideIdDataCancelToken = () => {};
export const getSpotQuoteRoutingGuideIdData = (params = {}) => {
  getSpotQuoteRoutingGuideIdDataCancelToken();
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE2}/GetSpotQuoteRoutingGuide`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getRoutingGuideIdDataCancelToken = c;
    }),
  });
};

// TODO
export const getCarrierServiceListEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetCarrierServiceList`,
    method: 'get',
    params,
  });
};

let createRoutingGuideEffectCancelToken = () => {};
export const createRoutingGuideEffect = (data) => {
  createRoutingGuideEffectCancelToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingHeader`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    cancelToken: new CancelToken(function executor(c) {
      createRoutingGuideEffectCancelToken = c;
    }),
  });
};

let createRoutingGuideUserEffectToken = () => {};
export const createRoutingGuideUserEffect = (data) => {
  createRoutingGuideUserEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostAddUserDetails`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      createRoutingGuideUserEffectToken = c;
    }),
  });
};

let deleteRoutingGuidesEffectToken = () => {};
export const deleteRoutingGuidesEffect = (params) => {
  deleteRoutingGuidesEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideHeader`,
    method: 'delete',
    data: params,
    cancelToken: new CancelToken(function executor(c) {
      deleteRoutingGuidesEffectToken = c;
    }),
  });
};

let checkNXPUserEffectCancelToken = () => {};
export const checkNXPUserEffect = () => {
  checkNXPUserEffectCancelToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetUserValidationforNXP`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      checkNXPUserEffectCancelToken = c;
    }),
  });
};

let getDownloadRoutingGuideExcelEffectToken = () => {};
export const getDownloadRoutingGuideExcelEffect = (params) => {
  getDownloadRoutingGuideExcelEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetDownloadRoutingGuideExcel`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getDownloadRoutingGuideExcelEffectToken = c;
    }),
  });
};

export const getDownloadRoutingGuideExcelTemplateEffect = ({ customerKey }) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetDownloadRoutingGuideExcelTemplate`,
    method: 'get',
    params: { customerKey },
  });
};

export const updateRoutingGuideTransportEffect = (data) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingDetails`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data.routingDetail,
  });
};

let routingGuideFileUploadEffectToken = () => {};
export const routingGuideFileUploadEffect = (data) => {
  routingGuideFileUploadEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostUploadRoutingGuideExcel`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    cancelToken: new CancelToken(function executor(c) {
      routingGuideFileUploadEffectToken = c;
    }),
  });
};

let getContentNXPRoutingGuideEffectToken = () => {};
export const getContentNXPRoutingGuideEffect = () => {
  getContentNXPRoutingGuideEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetDashboardContent`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getContentNXPRoutingGuideEffectToken = c;
    }),
  });
};

let updateContentNXPRoutingGuideEffectToken = () => {};
export const updateContentNXPRoutingGuideEffect = (data) => {
  updateContentNXPRoutingGuideEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingGuideContent`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
    cancelToken: new CancelToken(function executor(c) {
      updateContentNXPRoutingGuideEffectToken = c;
    }),
  });
};

export const getNXPUserTypesEffect = () => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetUserTypes`,
    method: 'get',
  });
};

let getNXPClientCodeEffectToken = () => {};
export const getNXPClientCodeEffect = () => {
  getNXPClientCodeEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetClientCode`,
    method: 'get',
    cancelToken: new CancelToken(function executor(c) {
      getNXPClientCodeEffectToken = c;
    }),
  });
};

let getNXPUserSearchListEffectToken = () => {};
export const getNXPUserSearchListEffect = (params) => {
  getNXPUserSearchListEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/GetUserSearchResult`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getNXPUserSearchListEffectToken = c;
    }),
  });
};

let deleteRoutingUserEffectToken = () => {};
export const deleteRoutingUserEffect = (params) => {
  deleteRoutingUserEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/DeleteRoutingUser`,
    method: 'delete',
    data: params,
    cancelToken: new CancelToken(function executor(c) {
      deleteRoutingUserEffectToken = c;
    }),
  });
};

let postSaveFileEffectToken = () => {};
export const postSaveFileEffect = (data) => {
  postSaveFileEffectToken();
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/PostSaveFile`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    cancelToken: new CancelToken(function executor(c) {
      postSaveFileEffectToken = c;
    }),
  });
};

export const deleteRoutingGuideTrasportationDetailsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideTrasportationDetails`,
    method: 'delete',
    params: params,
  });
};

export const postSaveRoutingAccessorialDetailsEffects = (data) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/SaveRoutingAccessorialDetails`,
    method: 'post',
    data,
  });
};

export const deleteRoutingGuideAccessorialEffect = (params) => {
  return axiosInstance.request({
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideAccessorial`,
    method: 'delete',
    params: params,
  });
};

export const getRoutingGuideCarriersEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/GetRoutingGuideCarriers`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${params?.routingGuideId}/carriers`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const getRoutingGuideCollaboratorsEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/GetRoutingGuideCollaborators`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${params?.routingGuideId}/collaborators`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const editRoutingGuideCarrierEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/PutRoutingGuideCarriers`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers`;

  return axiosInstance.request({
    url,
    method: 'put',
    data,
  });
};

export const editRoutingGuideCollaboratorEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/PutRoutingGuideCollaborators`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators`;

  return axiosInstance.request({
    url,
    method: 'put',
    data,
  });
};

export const addRoutingGuideCarrierEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/PatchRoutingGuideCarriers`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers`;

  return axiosInstance.request({
    url,
    method: 'patch',
    data,
  });
};

export const addRoutingGuideCollaboratorEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/PatchRoutingGuideCollaborator`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators/${data?.collaborator?.userId}`;

  return axiosInstance.request({
    url,
    method: 'patch',
    data,
  });
};

export const deleteRoutingGuideCarrierEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/DeleteRoutingGuideCarrier`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers/${data?.carrierId}`;

  return axiosInstance.request({
    url,
    method: 'delete',
    data,
  });
};

export const deleteRoutingGuideCollaboratorEffect = (data) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/DeleteRoutingGuideCollaborator`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators/${data?.collaboratorId}`;

  return axiosInstance.request({
    url,
    method: 'delete',
    data,
  });
};

export const getFilteredGuidesEffect = (params) => {
  const url = isHBUser ? `${API.SPOT_QUOTE2}/SearchRoutingGuides` : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/search`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const getExtendedCarrierAndBidDataEffect = (params) => {
  const url = isHBUser
    ? `${API.SPOT_QUOTE2}/GetExtendedCarrierAndBidData`
    : `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/carriers/extended`;

  return axiosInstance.request({
    url,
    method: 'get',
    params,
  });
};

export const getAllUsersNameEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SECURITY}/SearchUsers`,
    method: 'get',
    params,
  });
};
